(function ($, Drupal) {
  Drupal.behaviors.VanityMenu = {
    attach: function (context, settings) {

      $('.main-nav', context).once().delay(500).removeClass('d-none');

      $('.hamburger--collapse', context).once().on('click', function() {
        $(this).toggleClass('collapsed');
        $('.main-nav', context).toggleClass('show');
      });

    }
  }
})(jQuery, Drupal);
